import prepareOktaGroupSyncConfig from "authentication/logic/okta/prepareOktaGroupSyncConfig";
const prepareOktaLoadGroupsPayload = (prepareAuthBackendPayload, formValues, backendId, serviceType) => {
  const teamSyncAuthBackendId = backendId != null ? backendId : "<test>";
  const oktaConfig = prepareAuthBackendPayload(formValues);
  const groupSyncConfig = prepareOktaGroupSyncConfig(formValues, teamSyncAuthBackendId, serviceType);
  return {
    auth_service_backend_id: backendId,
    auth_service_backend_configuration: {
      ...oktaConfig
    },
    team_sync_backend_configuration: groupSyncConfig
  };
};
export default prepareOktaLoadGroupsPayload;
